/* eslint-disable */
export default {
  title: '音频',
  input: '输入',
  microphone: '麦克风',
  autoAdjustMicLevel: '自动调整麦克风音量',
  output: '输出',
  speakerSource: '扬声器音源',
  speakerVolume: '扬声器音量',
  ringtoneSource: '铃声和通知声源',
  ringtoneVolume: '铃声和通知音量',
  ringtones: '铃声',
  noDevices: '无设备',
  off: '关',
  noLabel: '未知设备',
  stopRecordDescription: '讲几句话来检查您的麦克风音量（{countDown} 秒）',
  stopPlaybackDescription: '正在播放录音…',
  startRecordButton: '测试麦克风',
  stopRecordButton: '停止录制',
  stopPlaybackButton: '停止测试',
  startTestButton: '测试扬声器',
  stopTestDescription: '正在播放音效样本…',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
